import { render, staticRenderFns } from "./json-clickable.vue?vue&type=template&id=3d29b82a&"
import script from "./json-clickable.vue?vue&type=script&lang=js&"
export * from "./json-clickable.vue?vue&type=script&lang=js&"
import style0 from "./json-clickable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports